export default __webpack_public_path__ + "static/media/template6.0ff20a4a.svg";